<template>
  <v-app>
      <v-content>
          <router-view></router-view>
      </v-content>
  </v-app>
</template>
<script>

export default {  
  name: 'App',
  components: {
  },
  created() {
    console.log(navigator.userAgent);
    this.$appUtil.setLauncher(navigator.userAgent);
    this.$langUtil.initLang(this.$i18n);
  },
  data: () => ({
  }),
  metaInfo: {
    title: 'MeconCashEX',
    meta: [
      { charset: 'utf-8'},
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'},
      { name: 'apple-mobile-web-app-capable', content: 'yes'},
      { 'http-equiv': 'Expires', content: '-1'},
      { 'http-equiv': 'Pragma', content: 'no-cache'},
      { 'http-equiv': 'Cache-Control', content: 'No-Cache'}
    ]
  },
  methods : {
  },
};
</script>

<style scoped>
</style>
